import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../../../../shared/services/message.service';

import { UrlConstants } from '../../../../shared/constants/urlparams.constants';
import { GeneralConstants } from '../../../../shared/constants/general.constants';

@Component({
  selector: 'app-configure-game',
  templateUrl: './configure-game.component.html',
  styleUrls: ['./configure-game.component.scss']
})
export class ConfigureGameComponent {
  constructor(private router: Router, private route: ActivatedRoute, private messageService: MessageService) { }

  onSubmit(gameName: string): void {
    this.configureGame(gameName);
  }

  configureGame(gameName: string) {
    let trimmedName: string = gameName.trim();
    if (trimmedName == "" || trimmedName == null) {
      this.messageService.showWarning("U heeft geen naam ingevoerd");
      return;
    }

    if (trimmedName.length > GeneralConstants.GameNameMaxLength) {
      this.messageService.showWarning("Een naam kan maximaal " + GeneralConstants.GameNameMaxLength + " tekens hebben");
      return;
    }

    try {
      let gameID = this.route.snapshot.paramMap.get(UrlConstants.GameID);
      this.router.navigate(["game/" + gameID + "/" + encodeURI(btoa(trimmedName))]);
    }
    catch (error) {
      this.messageService.showError("Er is iets fout gegaan tijdens het opslaan van de game naam, probeer het opnieuw");
    }
  }
}
